import TariffQuote from "../../models/TariffQuote.js"
import { Fuel, UsageType } from "./QuoteFormConstants.js"
import GatewayPortalV2 from "../api/GatewayPortalV2.js"

const getFuelTypeRaw = fuelType => {
  if (fuelType === Fuel.ElecAndGas) return "DUAL_FUEL"
  if (fuelType === Fuel.Electricity) return "ELECTRICITY_ONLY"
  if (fuelType === Fuel.Gas) return "GAS_ONLY"

  throw new Error("Invalid fuel type")
}

const getUsageType = usageType => {
  if (usageType === UsageType.low) return "LOW"
  if (usageType === UsageType.medium) return "MEDIUM"
  if (usageType === UsageType.high) return "HIGH"

  return "EXACT_AMOUNT"
}

const calcGasExactUsage = ({ fuel, exactAmountGas, estimatedUsage }) => {
  if (fuel === Fuel.Electricity || estimatedUsage || !exactAmountGas?.usage) {
    return ""
  }

  const usage = Math.round(Number(exactAmountGas.usage))
  return usage.toString()
}

const calcElecExactUsage = ({ fuel, exactAmountElec, estimatedUsage }) => {
  if (fuel === Fuel.Gas || estimatedUsage || !exactAmountElec?.usage) {
    return ""
  }

  const usage = Math.round(Number(exactAmountElec.usage))
  return usage.toString()
}

const isEligibleForEvTariff = quoteForm =>
  !!(
    quoteForm.hasSelectedEv &&
    quoteForm.hasValidEv &&
    quoteForm.hasMeterEligibleForEvTariff
  )

const parseQuoteInputData = quoteForm => {
  const mprn = quoteForm.supplyAddressGas?.mprn ?? quoteForm.supplyAddress.mprn
  const parsedData = {
    postcode: quoteForm.postcode,
    hasEconomySevenMeter: !!quoteForm.isMeterMultirate,
    estimatedUsageType: getUsageType(quoteForm.estimatedUsage),
    fuelType: getFuelTypeRaw(quoteForm.fuel),
    electricityUsagePerYearInKwh: calcElecExactUsage(quoteForm),
    gasUsagePerYearInKwh: calcGasExactUsage(quoteForm),
    generateQuotesForEvTariffs: isEligibleForEvTariff(quoteForm),
    mpan: quoteForm.supplyAddress.mpan
  }

  if (
    mprn &&
    (quoteForm.fuel === Fuel.ElecAndGas || quoteForm.fuel === Fuel.Gas)
  ) {
    parsedData.mprn = mprn
  }

  return parsedData
}

const findSoFlexQuote = quotes => {
  return quotes.find(quote => quote.elecProductCode.includes("SOOC"))
}

const findNonSoFlexQuotes = quotes => {
  return quotes.filter(quote => !quote.elecProductCode.includes("SOOC"))
}

const sortByCostPerYearInPounds = (a, b) =>
  a.costPerYearInPounds - b.costPerYearInPounds

export default {
  async getQuotes(quoteInputData) {
    const parsedInputData = parseQuoteInputData(quoteInputData)
    const response = await GatewayPortalV2.getQuote(parsedInputData)
    let rawQuotes = response.data ?? []

    if (rawQuotes.length) {
      const soFlexQuote = findSoFlexQuote(rawQuotes)

      if (quoteInputData.evTariffMarketingConsent && soFlexQuote) {
        rawQuotes.forEach(quote => (quote.isRecommended = false))
        const otherQuotes = findNonSoFlexQuotes(rawQuotes)
        otherQuotes.sort(sortByCostPerYearInPounds)
        rawQuotes = [soFlexQuote, ...otherQuotes]
      } else {
        rawQuotes.sort(sortByCostPerYearInPounds)
      }

      rawQuotes[0].isRecommended = true
    }

    return {
      quotes: rawQuotes.map(rawQuote => new TariffQuote(rawQuote))
    }
  }
}
